import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import axios from 'axios';

import { Button } from 'primereact/button';

import { Dialog } from 'primereact/dialog';
// import { Api } from '../../../../services/api';
// import { Api } from '../../../services/api';
import { Api } from '../../../../services/api';
import ProjectionAddModel from './projection-add';

const ProjectionSettingViewModal = ({getData, closeModel}) => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isProjectionSetting, setIsProjectionSetting] = useState(true);


// ------------------------------------------------------------



    const [isLoading, setIsLoading] = useState(false); // Add loading state

    const [projectionSetting, setProjectionSetting] = useState([]);
    const [projection, setProjection] = useState([]);

    // const API_BASE_URL = 'http://161.97.86.43/demo/lidahome/api/';

    useEffect(() => {
        setIsModalOpen(true);
    
        getProjectionSetting();

    }, [getData]);

    const getProjectionSetting = async () => {
        // axios.get(API_BASE_URL + 'get-all-projection-setting')
        axios.get(Api.API_BASE_URL + 'get-all-projection-setting')
            .then((response) => {

                setProjectionSetting(response.data.result);


            })
            .catch((error) => {

            });
    }

 

    // const formatCurrency = (value) => {
    //     return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    //   };
    
      
      
    const currencyColumnBodyTemplate = (rowData, column) => {
        return formatCurrency(rowData[column.field]);
      };
    
      const formatCurrency = (value) => {
        return '$' + value.toLocaleString('en-US');
      };
    
      const openEditModal = (rowData) =>{
        setIsEditModalOpen(true);
         setProjection(rowData);
      }    
       const closeModelAdd = () =>{
        setIsEditModalOpen(false);
        getProjectionSetting();
      }
      

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                {/* <Button icon="pi pi-copy" rounded outlined className="mr-2" /> */}
                <Button icon="pi pi-pencil" rounded outlined className="mr-2" onClick={() => openEditModal(rowData)} />

                {/* <Button icon="pi pi-pencil" rounded outlined className="mr-2" /> */}
              
            </React.Fragment>
        );
    };



    return (
        <>                
                    <Dialog header="" style={{ width: '70vw' }} visible={isProjectionSetting} maximizable modalcontentStyle={{ height: '300px' }} dismissableMask="true" onHide={() => {setIsProjectionSetting(false);closeModel()}}>
                    <div style={{ padding: '12px', }}>
                        <DataTable value={projectionSetting} scrollable selectionMode="single" showGridlines stripedRows lazy rowHover={true} scrollHeight="flex" tableStyle={{ tableLayout: 'fixed', width: 'auto', borderCollapse: 'separate', borderSpacing: '0' }}
                        >
                        <Column body={actionBodyTemplate} header="Action" exportable={false} style={{ minWidth: '12rem', textAlign: 'center' }}></Column>

                            <Column field="year" header="Year" style={{ minWidth: '80px', textAlign: 'center' }}></Column>
                            <Column field="month" header="Month" style={{ minWidth: '120px', textAlign: 'center' }}></Column>
                            <Column field="totalOtherIncome" header="Total Other Income"  body={currencyColumnBodyTemplate} style={{ minWidth: '120px', textAlign: 'center' }}></Column>
                            <Column field="MarketingSales" header="Marketing And Sales" body={currencyColumnBodyTemplate} style={{ minWidth: '120px', textAlign: 'center' }}></Column>
                            <Column field="AdminWages" header="Admin Wages" body={currencyColumnBodyTemplate} style={{ minWidth: '150px', textAlign: 'center' }}></Column>
                            <Column field="Facilities" header="Facilities" body={currencyColumnBodyTemplate} style={{ minWidth: '150px', textAlign: 'center' }}></Column>
                            <Column field="Office" header="Office" body={currencyColumnBodyTemplate} style={{ minWidth: '150px', textAlign: 'center' }}></Column>
                            <Column field="GeneralAdmin" header="General Admin" body={currencyColumnBodyTemplate} style={{ minWidth: '150px', textAlign: 'center' }}></Column>
                            <Column field="TotalOtherCurrentAssets" header="Total Other Current Assets" body={currencyColumnBodyTemplate} style={{ minWidth: '150px', textAlign: 'center' }}></Column>
                            <Column field="NumberOfEmployees" header="Number Of Employees" body={currencyColumnBodyTemplate} style={{ minWidth: '150px', textAlign: 'center' }}></Column>
                            <Column field="NumberOfManagementStaff" header="Number Of Management Staff" body={currencyColumnBodyTemplate} style={{ minWidth: '150px', textAlign: 'center' }}></Column>
                            <Column field="NumberOfPms" header="Number Of Pms" body={currencyColumnBodyTemplate} style={{ minWidth: '150px', textAlign: 'center' }}></Column>
                            <Column field="TotalAccountsReceievable" header="Total Accounts Receievable" body={currencyColumnBodyTemplate} style={{ minWidth: '150px', textAlign: 'center' }}></Column>
                            <Column field="MaterialsForFutureJobs" header="Materials For Future Jobs" body={currencyColumnBodyTemplate} style={{ minWidth: '150px', textAlign: 'center' }}></Column>
                            <Column field="DueFromToShareholder" header="Due From To Shareholder" body={currencyColumnBodyTemplate} style={{ minWidth: '150px', textAlign: 'center' }}></Column>
                            <Column field="WipCostsInExcessOfBillings" header="WipCosts In Excess Of Billings" body={currencyColumnBodyTemplate} style={{ minWidth: '150px', textAlign: 'center' }}></Column>
                            <Column field="TotalFixedAssets" header="Total Fixed Assets" body={currencyColumnBodyTemplate} style={{ minWidth: '150px', textAlign: 'center' }}></Column>
                            <Column field="TotalOtherAssets" header="Total Other Assets" body={currencyColumnBodyTemplate} style={{ minWidth: '150px', textAlign: 'center' }}></Column>
                            <Column field="TotalCurrentAssets" header="Total Current Assets" body={currencyColumnBodyTemplate} style={{ minWidth: '150px', textAlign: 'center' }}></Column>
                            <Column field="TotalCurrentLiabilities" header="Total Current Liabilities" body={currencyColumnBodyTemplate} style={{ minWidth: '150px', textAlign: 'center' }}></Column>
                            <Column field="TotalLongTermLiabilities" header="Total Long Term Liabilities" body={currencyColumnBodyTemplate} style={{ minWidth: '150px', textAlign: 'center' }}></Column>
                            <Column field="TotalEquity" header="Total Equity" body={currencyColumnBodyTemplate} style={{ minWidth: '150px', textAlign: 'center' }}></Column>
                            <Column field="CorpTaxPaid" header="Corp Tax Paid" body={currencyColumnBodyTemplate} style={{ minWidth: '150px', textAlign: 'center' }}></Column>
                            <Column field="ConstructionFinancing" header="Construction Financing" body={currencyColumnBodyTemplate} style={{ minWidth: '150px', textAlign: 'center' }}></Column>
                            <Column field="ToBalanceCash" header="To Balance Cash" body={currencyColumnBodyTemplate} style={{ minWidth: '150px', textAlign: 'center' }}></Column>
                            
                        </DataTable>
                    </div>
                </Dialog>  

                {/* ----------------------Projection Setting-----------------------------------------*/}
               
                {isEditModalOpen && <ProjectionAddModel visible={isEditModalOpen} projection={projection} closeModel={closeModelAdd}/>}
              
         
        </>
    )
}

export default ProjectionSettingViewModal

